import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory('/store/account'),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../pages/LoginWrapper.vue'),
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('../pages/OrderListPage.vue'),
    },
    {
      path: '/orders/:id',
      name: 'order-detail',
      component: () => import('../pages/OrderDetailPage.vue'),
    },
    {
      path: '/wishlist',
      name: 'wishlist',
      component: () => import('../pages/WishlistingScreen.vue'),
    },
    { path: '/:pathMatch(.*)*', redirect: '/orders' },
  ],
})

export default router
